import SelfServeDiscoBanner from './SelfServeDiscoBannerContainer';

export default SelfServeDiscoBanner;
